module.exports = __webpack_public_path__ + "img/a_e4.bf221ee9.png";